import cx from 'classnames';
import PropTypes from 'prop-types';
import * as colors from '../sass/base/_exports.sass';

export const Typography = ({
  className,
  classNames,
  color,
  size,
  inline,
  semibold,
  variant,
  style,
  ...props
}) => {
  // If there is already an h1 in the page, let's not duplicate it.

  // <Typography variant="h1" as="h2">
  //   This text uses an <h2> element but looks like an <h1>
  // </Typography>

  // todo - There seems to be a race condition preventing color
  // attributes from being respected in some nested components
  // (unless the same color has already been used
  // in a Typog element in a parent component)

  const colorValue = color && colors[color];
  const inlineStyles = {...style};
  if (colorValue) inlineStyles.color = colorValue;
  const Tag = props.as || 'p';

  return (
    <Tag
      className={cx(classNames, className, variant, size, {
        'semibold-text': !!semibold,
        inline,
      })}
      style={inlineStyles}
      {...props}
    >
      {props.children}
    </Tag>
  );
};

const typoMixins = [
  'header1',
  'header2',
  'header3',
  'header4',
  'header5',
  'paragraph1',
  'paragraph2',
  'paragraph3',
  'paragraph4',
  'list1',
  'list2',
  'label1',
  'label2',
  'label3',
  'link',
  'premium',
];

Typography.propTypes = {
  id: PropTypes.string,
  classNames: PropTypes.string,
  size: PropTypes.oneOf(['smaller', 'small', 'medium', 'large']),
  color: PropTypes.oneOf(Object.keys(colors)), // some of the keys here are not colors but good enough...
  variant: PropTypes.oneOf(typoMixins).isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string]).isRequired,
  'data-qa-id': PropTypes.string,
  as: PropTypes.string,
  inline: PropTypes.bool,
  htmlFor: PropTypes.string,
  semibold: PropTypes.bool,
};
